import React, {useEffect} from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate, useLocation } from "react-router-dom";
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import {
    Box
} from '@mui/material';
import { useAPIContext } from '../../Context/APIContext';
import { Document } from '../../Models/Document';
import { Star, StarBorder } from '@mui/icons-material';

type Props = {
    Documents: Document[];
    savedDocuments: Document[];
};

const DocumentTable: React.FC<Props> = ({ Documents, savedDocuments }) => {
    const navigate = useNavigate();
    const { apiFetch } = useAPIContext();
    const isDocumentSaved = (id: number): boolean =>
        savedDocs.some(doc => doc.id === id);

    const { state } = useLocation();
    
    const [savedDocs, setSavedDocs] = React.useState<Document[]>(savedDocuments);

    useEffect(() => {
        setSavedDocs(savedDocuments);
    }, [savedDocuments]);

    const NavigateToDocument = (document: Document) => {
        navigate(`/document/${document.id}`, { state: { ...state } });
    };

    const SaveDocument = async (saved: boolean, document: Document) => {
        if (saved) {
            const response = await apiFetch<number>(
            `Users/SavedDocuments`,
            'DELETE',
            document.id
            );

            if (response && response > 0) {
            setSavedDocs(prev => prev.filter(d => d.id !== document.id));
            }
        } else {
            const response = await apiFetch<number>(
            `Users/SavedDocuments`,
            'POST',
            document.id
            );

            if (response && response > 0) {
            setSavedDocs(prev => [...prev, document]);
            }
        }
    };


    return (
        <TableContainer sx={{ marginTop: '10px', marginBottom: '30px'}} component={Paper} elevation={3}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell><strong>Title</strong></TableCell>
                        <TableCell><strong>Saved</strong></TableCell>
                        <TableCell><strong>Points</strong></TableCell>
                        <TableCell><strong>View</strong></TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {Documents.map((doc) => {
                        const saved = isDocumentSaved(doc.id);

                        return (
                            <TableRow
                                key={doc.id}
                                hover
                                sx={{ '&:last-child td': { borderBottom: 0 } }}
                            >
                                <TableCell>
                                    {doc.title}
                                </TableCell>

                                <TableCell>
                                    <IconButton
                                        size="small"
                                        onClick={() => SaveDocument(saved, doc)}
                                    >
                                    {saved ? (
                                        <Star sx={{color: 'primary.main'}}/>
                                    ) : (
                                        <StarBorder sx={{color: 'primary.main'}}/>
                                    )}
                                    </IconButton>
                                </TableCell>

                                <TableCell>
                                    <Box
                                        sx={{
                                            width: 'fit-content',
                                            display: 'flex',
                                            alignItems: 'center',
                                            backgroundColor: '#f0f4f0', // Light background to make points stand out
                                            borderRadius: '5px',         // Rounded corners
                                            padding: '4px 4px',         // Padding inside the box
                                            color: '#66bb6a',            // Use the green color for the points
                                            fontWeight: 'bold',          // Make the text bold                            
                                        }}
                                    >
                                        <ElectricBoltIcon sx={{ color: '#66bb6a', marginRight: '4px' }} />
                                        {doc.points}
                                    </Box>
                                </TableCell>

                                <TableCell>
                                    <IconButton
                                        size="small"
                                        onClick={() => NavigateToDocument(doc)}
                                    >
                                        <OpenInNewIcon fontSize="small" />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default DocumentTable;
